/*
 * @Author: your name
 * @Date: 2021-06-02 15:32:01
 * @LastEditTime: 2021-10-09 13:57:42
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \ylfront-th-pudo-H5\store\modules\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import VueXAlong from 'vuex-along'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    /* token验证身份 */
    token: '',
    /* 站点编号 */
    stationCode: '',
    /* 语言环境 */
    langType: 'cn',
    system: '',
    status: false,
    weightRange: [],
    consultativeCode: ''
  },
  mutations: {
    setWeightRange(state, value) {
      state.weightRange = value
    },
    // 修改token
    updateToken(state, value) {
      state.token = value
    },
    // 修改站点编号
    updateStationCode(state, value) {
      state.stationCode = value
    },
    // 修改当前语言环境
    updateLangType(state, value) {
      state.langType = value
    },
    updateSystem(state, value) {
      state.system = value
    },
    updateStatus(state, value) {
      state.status = value
    },
    updateConsultativeCode(state, value) {
      state.consultativeCode = value
    }
  },
  plugins: [VueXAlong()]
})

export default store



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = vdRI
// module chunks = 17